var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsAndReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8961 60.7496C41.2504 60.7277 43.4844 61.2466 45.5601 62.3445C46.2593 62.7105 46.7181 62.6613 47.308 62.126C53.3056 56.6585 59.3142 51.1964 65.3718 45.7998C66.1639 45.0898 65.9072 44.4889 65.716 43.7734C63.46 35.2962 68.3379 27.5401 76.8481 26.0926C87.0244 24.3611 95.764 33.6576 93.2732 43.6751C92.8854 45.2263 93.2732 46.0456 94.393 47.0179C100.068 51.9174 105.684 56.8879 111.288 61.8748C112.025 62.5302 112.582 62.7433 113.566 62.3391C117.69 60.6567 121.857 60.5803 125.965 62.4046C126.724 62.7433 127.15 62.5739 127.708 62.0769C133.814 56.653 139.916 51.2237 146.088 45.8763C146.989 45.0952 146.716 44.407 146.52 43.5877C144.996 37.3281 147 31.3854 151.851 27.8132C157.024 24.0061 164.256 24.0716 169.368 27.9661C174.448 31.8387 176.344 38.7537 173.995 44.8549C171.701 50.814 165.66 54.572 159.236 54.0039C157.592 53.8564 155.969 53.4686 154.538 52.6438C153.681 52.1523 153.195 52.3817 152.556 52.9497C146.596 58.2316 140.642 63.5189 134.623 68.7242C133.727 69.4999 134.142 70.1662 134.322 70.8982C135.846 77.0758 133.787 83.1715 128.975 86.6836C123.873 90.4033 116.952 90.4415 111.84 86.7819C106.65 83.0677 104.411 76.464 106.366 70.4339C106.639 69.5982 106.503 69.1558 105.869 68.6041C99.8717 63.3659 93.8959 58.1059 87.942 52.8186C87.3357 52.2779 86.9042 52.2779 86.216 52.6329C82.0482 54.7741 77.8368 54.7959 73.6745 52.6548C72.888 52.2506 72.4401 52.3161 71.8119 52.8733C65.8198 58.1933 59.8222 63.5134 53.7645 68.757C52.9178 69.4889 53.3111 70.1171 53.4695 70.7944C54.8242 76.606 53.6388 81.7186 49.1871 85.8261C44.8555 89.8243 38.3663 90.6108 32.9531 87.9617C27.5182 85.2962 24.5412 79.6867 25.1148 73.1595C25.579 67.8722 29.6157 62.9617 34.7994 61.3286C36.1377 60.908 37.5032 60.7714 38.8907 60.7441L38.8961 60.7496Z",
    fill: "url(#paint0_linear_75_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1581 125.284C94.1581 141.31 94.1417 157.336 94.1854 173.367C94.1854 174.618 93.9123 175.011 92.5959 175C83.9655 174.94 75.3351 174.945 66.7046 174.994C65.5412 175 65.1424 174.743 65.1479 173.487C65.1861 141.277 65.1861 109.072 65.1479 76.8625C65.1479 75.5462 65.6231 75.3768 66.7429 75.3823C75.3241 75.4205 83.8999 75.4315 92.4812 75.3714C93.8195 75.3604 94.2018 75.6663 94.1964 77.0537C94.1417 93.1341 94.1636 109.209 94.1636 125.289L94.1581 125.284Z",
    fill: "url(#paint1_linear_75_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.579 125.11C174.579 141.135 174.563 157.167 174.607 173.193C174.607 174.558 174.317 175.017 172.859 175C164.278 174.929 155.702 174.935 147.12 175C145.81 175.011 145.52 174.613 145.52 173.356C145.553 141.25 145.553 109.144 145.52 77.0378C145.52 75.8088 145.777 75.361 147.115 75.3664C155.745 75.4265 164.376 75.4265 173.006 75.3664C174.334 75.3555 174.607 75.787 174.601 77.0269C174.563 93.0527 174.574 109.084 174.574 125.11H174.579Z",
    fill: "url(#paint2_linear_75_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.388 142.763C134.388 152.928 134.366 163.098 134.415 173.263C134.421 174.569 134.148 175.011 132.738 175C124.113 174.929 115.483 174.946 106.858 174.989C105.694 174.995 105.279 174.738 105.279 173.476C105.318 152.988 105.318 132.5 105.279 112.017C105.279 110.837 105.547 110.449 106.798 110.46C115.477 110.515 124.152 110.526 132.831 110.46C134.191 110.449 134.41 110.908 134.404 112.121C134.361 122.34 134.382 132.554 134.382 142.774L134.388 142.763Z",
    fill: "url(#paint3_linear_75_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0375 142.687C54.0375 152.912 54.0157 163.131 54.0649 173.356C54.0703 174.613 53.7808 175.006 52.4699 174.995C43.8394 174.935 35.209 174.935 26.5786 174.995C25.2403 175.006 25 174.569 25 173.34C25.0382 152.945 25.0437 132.555 25 112.159C25 110.837 25.284 110.439 26.6769 110.449C35.2582 110.52 43.834 110.526 52.4152 110.449C53.8464 110.439 54.0812 110.881 54.0703 112.175C54.0212 122.346 54.043 132.516 54.043 142.687H54.0375Z",
    fill: "url(#paint4_linear_75_59)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_59",
    x1: 100.019,
    y1: 25.001,
    x2: 100.019,
    y2: 89.5068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_59",
    x1: 79.6721,
    y1: 75.3711,
    x2: 79.6721,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_59",
    x1: 160.063,
    y1: 75.3662,
    x2: 160.063,
    y2: 175.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_59",
    x1: 119.847,
    y1: 110.46,
    x2: 119.847,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_59",
    x1: 39.5353,
    y1: 110.449,
    x2: 39.5353,
    y2: 174.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsAndReporting);
export default __webpack_public_path__ + "static/media/Analytics_and_Reporting.7776e3e0cf44293b8369145627ad9c3c.svg";
export { ForwardRef as ReactComponent };